import React from 'react';
import Slide from '@material-ui/core/Slide';
import {Dialog, DialogActions, DialogContent, DialogContentText, List, Button, ListItem, ListItemIcon, Avatar, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
//Styles
import {useStyles} from './style';
import Title from 'components/TitleWithIcon';
import { Send } from '@material-ui/icons';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalConfimation(props) {
    const classes = useStyles();
    // console.log('props.textoObservacion', props.textoObservacion);
    return (
        <div>
            <Dialog     open={props.open}
                        maxWidth={"sm"}
                        fullWidth
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={props.handleClose}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
            >
                <Title title={props.title} icon={"/assets/comments.svg"}/>
                <DialogContent dividers>
                    <DialogContentText id="alert-dialog-slide-description">
                        {
                            props.textoObservacion && (
                                <List>
                                    {
                                        props.textoObservacion.map((text, index) => {
                                            return (
                                                    <ListItem>
                                                        <ListItemIcon>
                                                            <Send color="primary"/>
                                                        </ListItemIcon>
                                                        <ListItemText style={{color: 'black'}}
                                                            primary={text.title}
                                                        />
                                                        <ListItemSecondaryAction style={{color: '#3B3B3B'}}>
                                                            {text.text}
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                            )
                                        })                                
                                    }
                                </List>                                    
                            )
                        }
                    </DialogContentText>
               </DialogContent>
                <DialogActions>                    
                    <Button autoFocus onClick={props.handleClose} color="secondary" variant="outlined">
                        Cerrar
                    </Button>
                </DialogActions>
                <div className={classes.lineaDegradadaBottom}></div>
            </Dialog>
        </div>
    );
}